export default __webpack_public_path__ + "static/media/Group 49.bf62380f.png";